import React from 'react';
import { useSelector } from 'react-redux';
import Step from './Step';
import StepIndicatorConnector from './StepIndicatorConnector';

const ContentsList = () => {
  const { steps } = useSelector(state => state);

  return (
    <div
      className="PathContentsList JourneyContentsList"
      data-testid="JourneyContentsList"
    >
      {steps.map((step, index) => {
        return <Step step={step} index={index + 1} key={step.stepId} />;
      })}
      <StepIndicatorConnector />
    </div>
  );
};

export default ContentsList;
